var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-table',{staticClass:"m-b",attrs:{"data":_vm.supplierList}},[_c('el-table-column',{attrs:{"label":"序号","type":"index"}}),_c('el-table-column',{attrs:{"label":"供应商名称","prop":"supplierName"}}),_c('el-table-column',{attrs:{"label":"报价状态","formatter":_vm.formatter1}}),_c('el-table-column',{attrs:{"label":"报价时间","formatter":_vm.formatter2}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }